import React from 'react';
import { StatsBar, StatCard, StatValue, StatLabel } from './styles';

const pluralize = (count, singular, plural) => count === 1 ? singular : (plural || `${singular}s`);

const CertificationsStats = ({ stats, showIssuers = false }) => {
  if (!stats) {
    return null;
  }

  return (
    <StatsBar>
      <StatCard>
        <StatValue>{stats.totalEmployees}</StatValue>
        <StatLabel>{pluralize(stats.totalEmployees, 'Individual')}</StatLabel>
      </StatCard>
      <StatCard>
        <StatValue>{stats.totalCertifications}</StatValue>
        <StatLabel>{pluralize(stats.totalCertifications, 'Certification')}</StatLabel>
      </StatCard>
      {showIssuers && stats.totalIssuers !== undefined && (
        <StatCard>
          <StatValue>{stats.totalIssuers}</StatValue>
          <StatLabel>{pluralize(stats.totalIssuers, 'Issuer')}</StatLabel>
        </StatCard>
      )}
      <StatCard $bgColor="#D1FAE5" $borderColor="#A7F3D0">
        <StatValue $color="#059669">{stats.valid}</StatValue>
        <StatLabel>Valid</StatLabel>
      </StatCard>
      <StatCard $bgColor="#FEF3C7" $borderColor="#FDE68A">
        <StatValue $color="#D97706">{stats.expiringSoon}</StatValue>
        <StatLabel>Expiring Soon</StatLabel>
      </StatCard>
      <StatCard $bgColor="#FEE2E2" $borderColor="#FECACA">
        <StatValue $color="#DC2626">{stats.expired}</StatValue>
        <StatLabel>Expired</StatLabel>
      </StatCard>
      <StatCard>
        <StatValue>{stats.noExpiration}</StatValue>
        <StatLabel>No Expiration</StatLabel>
      </StatCard>
    </StatsBar>
  );
};

export default CertificationsStats;
